import { getExpectedAdminPin } from '@/config/adminPin';

const STORAGE_KEY = 'admin_session_until';
const PIN_FINGERPRINT_KEY = 'admin_session_pin';

/** Длительность сессии администратора после ввода PIN — 8 часов (вкладка). */
const SESSION_MS = 8 * 60 * 60 * 1000;

function storage() {
  return sessionStorage;
}

/** Отпечаток PIN, чтобы после смены кода старый вход в этой вкладке сразу стал недействителен. */
function pinFingerprint(pin) {
  const s = String(pin ?? '');
  let hash = 5381;
  for (let i = 0; i < s.length; i += 1) {
    hash = ((hash << 5) + hash + s.charCodeAt(i)) >>> 0;
  }
  return `${s.length}:${hash}`;
}

function currentPinFingerprint() {
  return pinFingerprint(getExpectedAdminPin());
}

export function setAdminSession() {
  storage().setItem(STORAGE_KEY, String(Date.now() + SESSION_MS));
  storage().setItem(PIN_FINGERPRINT_KEY, currentPinFingerprint());
}

export function clearAdminSession() {
  storage().removeItem(STORAGE_KEY);
  storage().removeItem(PIN_FINGERPRINT_KEY);
}

export function isAdminSessionValid() {
  const raw = storage().getItem(STORAGE_KEY);
  if (!raw) return false;
  const until = parseInt(raw, 10);
  if (Number.isNaN(until) || Date.now() >= until) {
    clearAdminSession();
    return false;
  }
  const storedPin = storage().getItem(PIN_FINGERPRINT_KEY);
  if (!storedPin || storedPin !== currentPinFingerprint()) {
    clearAdminSession();
    return false;
  }
  return true;
}

/**
 * Безопасный путь после входа: только относительные пути приложения, без open redirect.
 */
export function getSafeAdminRedirect(redirect) {
  if (typeof redirect !== 'string' || !redirect.startsWith('/') || redirect.startsWith('//')) {
    return '/admin/menu';
  }
  const pathOnly = redirect.split('?')[0];
  if (pathOnly === '/admin' || pathOnly === '/admin/') {
    return '/admin/menu';
  }
  return redirect;
}
